export const REGEX_CONSTANT = Object.freeze({
  // eslint-disable-next-line max-len
  email: new RegExp(
    /^[a-zA-Z0-9.!#$%&'*+=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
  ),
  password: new RegExp(
    /^(?=^.{12,20}$)((?=.*\d)(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/
  ),
  numeric: new RegExp(/^[0-9]+$/),
  AlphanumericWithSpace: new RegExp(/^[a-zA-Z0-9\s]+$/),
  startOfLine: /^\n\s/gm,
  imageExtensionPattern: /[^"'<>]+\.(?:png|jpe?g|gif)\b/gi,
  pdfPattern: /[^"'<>]+\.(?:pdf)\b/gi,
  upperCamelCase: /([A-Z])/gm,
  firstForwardSlashMatch: /^.*?\//gm,
  urlToPhoto: /\/([^/?]+)\?/,
  alphaNumeric: /^[a-zA-Z0-9]+$/,
  panCard: /^[a-zA-Z0-9]{,10}$/,
  aadharCard: /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1,12}?$/,
  phoneNumber: /^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/,
  titleCheck: /\.(.*?)(?=\.)/,
  armKeyNumber: /^arn:(aws[a-zA-Z-]*)?:[a-z0-9-]+:[a-z0-9-]*:\d{12}:[^:\s]+$/,
  noCapitalAlphabets:'/^(?!.*[A-Z]).*$/',
  nameRegex : /^[a-zA-Z][a-zA-Z0-9\s@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{0,30}$/,
  domainPatternRegex : /^(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,})$/,
});

// TODO: try to create another file to give error message for above regex's
// export const UPSERT_CLIENT_MESSAGE_CONSTANT = {
//   [UPSERT_CLIENT_CONSTANT.name.key as AttrKeys]: {
//     pattern: 'Please start name with alphabets',
//   },

// };